const smtpServerTab =  {
    LOAD_SMTP_SERVER_TAB: "LOAD_SMTP_SERVER_TAB",
    LOADED_SMTP_SERVER_TAB: "LOADED_SMTP_SERVER_TAB",
    ERROR_LOADING_SMTP_SERVER_TAB: "ERROR_LOADING_SMTP_SERVER_TAB",
    CHANGE_SMTP_SERVER_MODE: "CHANGE_SMTP_SERVER_MODE",
    CHANGE_SMTP_AUTHENTICATION: "CHANGE_SMTP_AUTHENTICATION",
    CHANGE_SMTP_CONFIGURATION_VALUE: "CHANGE_SMTP_CONFIGURATION_VALUE",
    UPDATE_SMTP_SERVER_SETTINGS: "UPDATE_SMTP_SERVER_SETTINGS",
    UPDATED_SMTP_SERVER_SETTINGS: "UPDATED_SMTP_SERVER_SETTINGS",
    ERROR_UPDATING_SMTP_SERVER_SETTINGS: "ERROR_UPDATING_SMTP_SERVER_SETTINGS",
    SEND_TEST_EMAIL: "SEND_TEST_EMAIL",
    SENT_TEST_EMAIL: "SENT_TEST_EMAIL",
    ERROR_SENDING_TEST_EMAIL: "ERROR_SENDING_TEST_EMAIL",
    LOAD_OAUTH_PROVIDERS: "LOAD_OAUTH_PROVIDERS",
    LOADED_OAUTH_PROVIDERS: "LOADED_OAUTH_PROVIDERS"
};

export default smtpServerTab;